const { subscribeMutationObserver } = require('../utils/helpers');
const { Swiper, Navigation } = require('swiper');

Swiper.use([Navigation]);

function initRecommendationsSlider() {
    const swiper = new Swiper('.js-recommendations-carousel', {
        slidesPerView: 2,
        slidesPerGroup: 2,
        watchOverflow: true,
        breakpoints: {
            768: {
                slidesPerView: 4,
                slidesPerGroup: 4
            }
        },
        navigation: {
            nextEl: '.js-recommendations-next',
            prevEl: '.js-recommendations-prev'
        }
    });
}

function init() {
    const $recommendationWrapper = $('.js-recommendations-wrapper');

    subscribeMutationObserver($recommendationWrapper, function() {
        if ($('.js-recommendations-carousel').length) {
            reinit();
            $recommendationWrapper.trigger('disconnectObserver');
        }
    });
}

// Inits the carousel when its markup is already in the DOM. Idempotent (data flag guards a
// second Swiper). Used by the observer and after the empty-cart recs are fetched via AJAX.
function reinit() {
    const $carousel = $('.js-recommendations-carousel');

    if ($carousel.length && $carousel.attr('data-rec-carousel-init') !== 'true') {
        $carousel.attr('data-rec-carousel-init', 'true');
        initRecommendationsSlider();
    }
}

module.exports = {
    init,
    reinit
};
